/**
 * Display the results of the PartQohLocationsLookup query that is stored in
 * dynamicInputResult field of the request
 * @param {Local.PartQohLocationsLookupProps} props
 */
export const PartQohLocationsLookup = ({ results }) => {
  if (!results?.length || !results[0].description) return null;
  const [description] = results[0].description.split(',');
  const locatorInfo = results.map((result) => `*** ${result.locator} (${result.qoh})`);
  return <span data-testid='dynamic-input-result'>{`${description} ${locatorInfo.join(' ')}`}</span>;
};
